
import { Dialog, DialogProps, DialogTitle } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';

const useStyles = makeStyles({
	SpinningWrapper: {
		display: 'grid',
		opacity: 0.999,
	},
	above: {
		gridColumn: 1,
		gridRow: 1,
		zIndex: 1,
	},
	below: {
		gridColumn: 1,
		gridRow: 1,
		zIndex: -1,
	},
	spinner: {
		gridColumn: 1,
		gridRow: 1,
		opacity: 0.5,
		display: 'grid',
		alignItems: 'center',
		justifyItems: 'center',
		backgroundColor: '#AAA',
		overflow: 'hidden',
	},
});

type IBusyDialogProps = Omit<DialogProps, 'open'> & {
	open?: boolean
	isBusy: boolean
	title: React.ReactNode
};

export const BusyDialog = observer(function BusyDialog(props: IBusyDialogProps) {
	const classes = useStyles();
	const {open, isBusy, title, children, ...rest} = props;
	return <Dialog open={open ?? true} {...rest}>
		<DialogTitle>{title}</DialogTitle>
		<div className={classes.SpinningWrapper}>
			<div className={isBusy ? classes.below : classes.above}>{children}</div>
			{!isBusy ? null : <div className={classes.spinner}><CircularProgress/></div>}
		</div>
	</Dialog>;
});
